import { DataToWidgetWompi } from "../dataToWidgetWompi";
import { ResponseCustomer } from "../response-customer";

export abstract class CheckoutWompiGateway {
    abstract checkoutWidget(dataToWompi: DataToWidgetWompi): void;
}